import _ from "lodash"

import Model from "../../model"
import assert from "../../../services/assert"
import { Idea, ID, Project } from "../../types"
import Command, { CommandName } from "../command"
import CreateIdeaCommand from "./create_idea_command"

export type DeleteIdeasCommandState = {
  ids: ID[]
  captured?: {
    ideas: Idea[]
    presentInProjectsWithIndex: [ID, number][][]
    isGoalForSources: ID[][]
  }
}

export default class DeleteIdeasCommand extends Command {
  name: CommandName = "delete-ideas"
  state: DeleteIdeasCommandState

  constructor(state: DeleteIdeasCommandState) {
    super()
    this.state = state
  }

  // Possible conflicts:
  //   - idea has been deleted already (Resolve, Cancel)
  resolveConflicts(model: Model): DeleteIdeasCommandState | null {
    const newIds = this.state.ids.filter((id) => {
      return !!model.getIdea(id)
    })
    if (newIds.length) return { ..._.cloneDeep(this.state), ids: newIds }
    else return null
  }

  local(model: Model): any {
    this.state.captured = {
      ideas: this.state.ids.map((id) => model.fetchIdea(id)),
      presentInProjectsWithIndex: this.state.ids.map((id) =>
        model.getProjectsForIdea(id).map((p) => {
          return [p.id, p.ideaIds.indexOf(id)]
        })
      ),
      isGoalForSources: this.state.ids.map((id) =>
        model.getSourcesWithGoal(id).map((s) => s.id)
      ),
    }
    model.deleteIdeas(this.state.ids)
  }

  undo(): Command[] {
    assert(this.state.captured)

    return this.state.captured.ideas.map((idea, i) => {
      const projectIndexes = this.state.captured?.presentInProjectsWithIndex[i]
      const goalSources = this.state.captured?.isGoalForSources[i]

      return new CreateIdeaCommand({
        id: this.state.ids[i],
        idea,
        inProjectsWithIndex: projectIndexes,
        isGoalForSources: goalSources,
      })
    })
  }
}
